var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("common-layout-component2", {
    attrs: { "show-back": "false", "show-user": "false" },
    scopedSlots: _vm._u([
      {
        key: "nav-message",
        fn: function() {
          return [_c("p", [_vm._v("カテゴリ選択")])]
        },
        proxy: true
      },
      {
        key: "nav-ctrl",
        fn: function() {
          return undefined
        },
        proxy: true
      },
      {
        key: "body",
        fn: function() {
          return [
            _c("div", { staticClass: "container" }, [
              _c(
                "div",
                { staticClass: "columns is-multiline cat-wrapper" },
                [
                  _vm._l(_vm.categories, function(item) {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "column is-half cat-item",
                          class: { "no-task": item.total_tasks == 0 }
                        },
                        [
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: item.total_tasks == 0,
                                  expression: "item.total_tasks == 0"
                                }
                              ],
                              attrs: { href: "#" }
                            },
                            [_c("h2", [_vm._v(_vm._s(item.category_name))])]
                          ),
                          _vm._v(" "),
                          _c(
                            "router-link",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: item.total_tasks > 0,
                                  expression: "item.total_tasks > 0"
                                }
                              ],
                              attrs: { to: "/user/tasks/" + item.category_id }
                            },
                            [_c("h2", [_vm._v(_vm._s(item.category_name))])]
                          )
                        ],
                        1
                      )
                    ]
                  })
                ],
                2
              )
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }